import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from '../tabs';

export function CarBrandLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
